module.exports = __webpack_public_path__ + "static/img/agua.1d19a10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/agua.jpg
// module id = CmTk
// module chunks = 1